import people from "@/data/people";

class PeopleService {
  getAll(lang) {
    return people[lang];
  }
}

export default new PeopleService();
